import { render, staticRenderFns } from "./PortfolioEvent.vue?vue&type=template&id=46a16622&scoped=true&"
import script from "./PortfolioEvent.vue?vue&type=script&lang=js&"
export * from "./PortfolioEvent.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioEvent.vue?vue&type=style&index=0&id=46a16622&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a16622",
  null
  
)

export default component.exports